import { Card, CardContent, List, ListItem, ListItemIcon, ListItemText } from "@/components/ui";
import { ViewEventoInsegnamento } from "@/components/ViewEventoInsegnamento/ViewEventoInsegnamento";
import { APP_DATE_FORMAT } from "@/config/constants";
import { IEdoCourseEvent } from "@/shared/model/edo-course-event.model";
import axios from "axios";
import { CalendarDays } from "lucide-react";
import { useEffect, useState } from "react";
import { TextFormat, Translate } from "react-jhipster";

export const Eventi = () => {
  const [edoCourseEventList, setEdoCourseEventList] = useState<IEdoCourseEvent[]>(
    []
  );
  const [viewEvent, setViewEvent] = useState<boolean>(false);
  const [eventToView, setEventToView] = useState<IEdoCourseEvent | null>(null);

  const getEdoCourseEventList = async () => {
    const response = await axios.get("/account/events", {
      // params: {
      //   // ['edoInsegnamentoId.equals']: String(insegnamento.id),
      //   page: 0,
      //   size: 5,
      //   sort: 'dataInizio:DESC',
      //   cacheBuster: new Date().getTime(),
      // },
    });
    setEdoCourseEventList(response.data);
  };

  const openViewEvent = (event: IEdoCourseEvent) => {
    setViewEvent(true);
    setEventToView(event);
  };

  useEffect(() => {
    getEdoCourseEventList();
  }, []);

  // useEffect(() => {
  //   if (insegnamento.id) {
  //     getEdoCourseEventList();
  //   }
  // }, [insegnamento.id]);

  //   useEffect(() => {
  //     if (insegnamento.id) {
  //       getEdoCourseEventList();
  //     }
  //   }, [updateSuccess]);

  return (
    <>
      <Card className="overflow-hidden rounded-3xl border border-[var(--color-mockup-border)] p-0 shadow-card">
        <div className="border-b border-[var(--color-mockup-border)] bg-[var(--color-surface-secondary)]/30 px-5 py-3">
          <p className="text-sm font-heading font-bold text-[var(--color-mockup-text)]">Eventi</p>
        </div>
        <CardContent className="p-0 last:pb-0">
          <List className="divide-y divide-[var(--color-mockup-border)]">
            {edoCourseEventList && edoCourseEventList.length ? (
              edoCourseEventList.map((event) => (
                <ListItem
                  key={event.id}
                  className="flex cursor-pointer items-center gap-3 px-5 py-2.5 transition-colors hover:bg-primary/5"
                  onClick={() => openViewEvent(event)}
                >
                  <ListItemIcon className="shrink-0">
                    <div className="flex h-8 w-8 items-center justify-center rounded-3xl bg-primary/10 text-primary">
                      <CalendarDays className="h-4 w-4" />
                    </div>
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <span className="text-sm font-medium text-[var(--color-mockup-text)] line-clamp-2">
                        {event.title}
                      </span>
                    }
                    secondary={
                      <span className="text-xs text-[var(--color-mockup-text-light)]">
                        <TextFormat
                          value={event.startDate}
                          type="date"
                          format={APP_DATE_FORMAT}
                        />
                      </span>
                    }
                  />
                </ListItem>
              ))
            ) : (
              <div className="px-5 py-4 text-center text-sm text-[var(--color-mockup-text-mid)]">
                <Translate contentKey="edocendoApp.edoCourseEvent.home.notFound">
                  No Edo Event Insegnamentos found
                </Translate>
              </div>
            )}
          </List>
        </CardContent>
      </Card>

      <ViewEventoInsegnamento
        open={viewEvent}
        handleClose={() => setViewEvent(false)}
        eventId={eventToView?.id}
      />
    </>
  );
};

export default Eventi;
